import styled, { css } from 'styled-components';

import Plane from '@lt/components/icons-react/userflow/Plane';
import BaloonHolidays from '@lt/components/icons-react/BaloonHolidays';
import Calendar from '@lt/components/icons-react/userflow/Calendar';

const presetCategoryIconStyles = css`
  margin: 8px;

  width: 24px;
  height: 24px;

  float: left;

  & path {
    stroke: #919499;
  }
`;

const PlaneIcon = styled(Plane)`
  ${presetCategoryIconStyles}
`;

const BaloonHolidaysIcon = styled(BaloonHolidays)`
  ${presetCategoryIconStyles}
`;

const CalendarIcon = styled(Calendar)`
  ${presetCategoryIconStyles}

  && {
    margin: 11px;

    width: 18px;
    height: 18px;
  }
`;

export const PRESET_CATEGORY_NAME_TO_ICON = {
  nearest_dates: PlaneIcon,
  events: BaloonHolidaysIcon,
  seasons: CalendarIcon,
};
